"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro práci s geodaty. Generated from cz.marbes.api.objekt.v1.GeodataService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:59:53Z                      #

// ##############################################################

var GeodataApi = function () {
  function GeodataApi() {
    (0, _classCallCheck3.default)(this, GeodataApi);
  }

  (0, _createClass3.default)(GeodataApi, null, [{
    key: "getPopisGeometry",

    /**
     * Vrátí objekty popisující geometrický útvar
     *
     * @param geometry - {@link org.geojson.Geometry} nebo {@link org.geojson.GeometryCollection}
     * @return - objekty popisující části geometrie
     */
    value: function getPopisGeometry(geometry) {
      var uri = serverContextPath + "/api/objekt/v1/geodata/popis/geometry";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, geometry, headers));
    }

    /**
     * Vrátí geometrii vykreslující danou adresu. <p> Výslednou geometrií může být {@link org.geojson.LineString}, {@link org.geojson.Point} nebo {@link org.geojson.GeometryCollection} obsahující předchozí uvedené.
     *
     * @param popis uživatelský popis adresy
     * @return geometrie
     */

  }, {
    key: "getAdresaGeometryByPopis",
    value: function getAdresaGeometryByPopis(popis) {
      var uri = serverContextPath + "/api/objekt/v1/geodata/adresa/geometry";
      var headers = undefined;
      var params = { popis: popis };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí uživatelsk popis adresy, která se nachází pod daným geometrickým objektem.
     *
     * @param geometry {@link org.geojson.Geometry} nebo {@link org.geojson.GeometryCollection}
     * @return uživatelský popis adresy
     */

  }, {
    key: "getAdresaPopisByGeometry",
    value: function getAdresaPopisByGeometry(geometry) {
      var uri = serverContextPath + "/api/objekt/v1/geodata/adresa/popis";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, geometry, headers));
    }
  }]);
  return GeodataApi;
}();

exports.default = GeodataApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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